exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-header-title[data-v-229c2534]{\n  font-weight:500;\n  font-size:20px;\n  line-height:44px;\n  margin:10px 0 16px 4px\n}", ""]);

// exports
